// Styles
import './template-collection.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initTemplateCollection = (context) => {
  const templateCollectionSection = context.closest('.shopify-section');
  if (!templateCollectionSection) return;

  $('[grid-settings-wrapper] .grid-settings svg').each(function () {
    $(this).on('click', function (event) {
      const cols = $(this).attr('cols');
      const $grid_settings_wrapper = $("[grid-settings-wrapper]");
      $grid_settings_wrapper.removeClass();
      $grid_settings_wrapper.addClass('grid-' + cols + '-col');
    });
  });

  $('#CollectionSection .collection-extra-section__opener').each(function () {
    $(this).on('click', function (event) {
      const link = $(this).attr('popup-link');
      $("#CollectionSection .collection-extra__popup")
        .load(link + " #PageContainer .main-content > div", function () {
          $(this).removeClass('spin');
        });
      event.preventDefault();
    });
  });

  // Manage active filters' tags

  const activeFilters = templateCollectionSection.querySelector('#FacetFiltersForm .filters__active-filters');
  activeFilters.querySelectorAll('.filters__active-filters__filter').forEach(activeLabel => {
    activeLabel.addEventListener('click', function () {
      activeLabel.style.display = 'none';
      activeLabel.classList.remove('active');

      if (document.querySelectorAll('label.filters__active-filters__filter.active').length == 0) {
        document.querySelector('.active-facets__button-wrapper').style.display = 'none';
      } else {
        document.querySelector('.active-facets__button-wrapper').style.display = '';
      }
    });
  });

  templateCollectionSection.querySelectorAll('#FacetFiltersForm .js-filter input[type="checkbox"]').forEach(checkbox => {
    const activeLabel = activeFilters.querySelector(`label[for="${checkbox.id}"]`);

    checkbox.addEventListener('change', function () {
      if (activeLabel) {
        if (checkbox.checked) {
          activeLabel.style.display = '';
          activeLabel.classList.add('active');
        } else {
          activeLabel.style.display = 'none';
          activeLabel.classList.remove('active');
        }
      }

      if (document.querySelectorAll('label.filters__active-filters__filter.active').length == 0) {
        document.querySelector('.active-facets__button-wrapper').style.display = 'none';
      } else {
        document.querySelector('.active-facets__button-wrapper').style.display = '';
      }
    });
  });

  // Manage filters removal

  const applyFilters = document.querySelector('.collection-filters__filter-drawer__btn--apply');
  const removeFilters = document.querySelector('.collection-filters__filter-drawer__btn--remove');
  removeFilters?.addEventListener('click', () => {
    const selectedFilters = document.querySelectorAll('#FacetFiltersForm .js-filter input[type="checkbox"]:checked');
    if (selectedFilters.length > 0) {
      selectedFilters.forEach(checkbox => {
        checkbox.checked = false;

        const activeLabel = templateCollectionSection.querySelector(`label.filters__active-filters__filter[for="${checkbox.id}"]`);
        activeLabel.style.display = 'none';
        activeLabel.classList.remove('active');

      });

      applyFilters.click();

      if (document.querySelectorAll('label.filters__active-filters__filter.active').length == 0) {
        document.querySelector('.active-facets__button-wrapper').style.display = 'none';
      } else {
        document.querySelector('.active-facets__button-wrapper').style.display = '';
      }
    }
  });
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('#CollectionSection'), (el) => {
    window.dAgency.initTemplateCollection(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('#CollectionSection'), (el) => {
      window.dAgency.initTemplateCollection(el);
    });
  });
}
